import { Card, Tabs, Typography, Rate, Descriptions, Collapse } from "antd";
import { useGetConsumptionEntriesQuery } from "../../generated/graphql";
import consumption_types from "../../local_data/consumption_types";
import { useParams } from "react-router-dom";
const { Panel } = Collapse;

const { TabPane } = Tabs;
const { Title } = Typography;
interface Props {
  productEntryId: string;
}     

const callback = (key: any) => {
  console.log(key);
}

const formatDate = (date: Date) => {
  var mm = date.getMonth() + 1; // getMonth() is zero-based
  var dd = date.getDate();

  return [date.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
         ].join('');
};


export const EntryList = (props: Props) => {
  const {productEntryId} = props;
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useGetConsumptionEntriesQuery({
    variables: { productEntryId: productEntryId },
  });

  const consumptionTypeLookUp = (id: any) =>  consumption_types.find(x => x.consumption_id === id);

  interface RatingsProps {
    index: number;
  }
  const userFeelingcategories = [
    "Sad/Happy",
    "Couchlock/Energetic",
    "Anxious/Mellow",
    "Unfocused/Focused",
    "High Pain/Low Pain",
  ];
  return (
    <div style={{display:"flex", 
  flexFlow: "row wrap",alignItems:"flex-start",
  justifyContent: "space-around"}}>
      {loading ? (
        <Title level={4}>Entries are loading...</Title>
      ) : (
        data?.consumption_enteries.map(
          ({
            product_entry_id,
            consumption_type_id,
            user_id,
            user_description,
            user_rating,
            rating_1_before,
            rating_2_before,
            rating_3_before,
            rating_4_before,
            rating_5_before,
            rating_6_before,
            rating_7_before,
            rating_8_before,
            rating_9_before,
            rating_10_before,
            rating_1_after,
            rating_2_after,
            rating_3_after,
            rating_4_after,
            rating_5_after,
            rating_6_after,
            rating_7_after,
            rating_8_after,
            rating_9_after,
            rating_10_after,
            rating_1_question_id,
            rating_2_question_id,
            rating_3_question_id,
            rating_4_question_id,
            rating_5_question_id,
            rating_6_question_id,
            rating_7_question_id,
            rating_8_question_id,
            rating_9_question_id,
            rating_10_question_id,
          }, index) => {
            const numberRating = (user_rating && parseFloat(user_rating)) || 3;
            // const userAfterFeeling = user_after_feeling
            //   ?.split("[")[1]
            //   ?.split("]")[0]
            //   ?.split(",");
            // userAfterFeeling?.pop();
            // const finalUserAfterFeeling = userAfterFeeling?.map((value) =>
            //   parseFloat(value)
            // );
            // const userBeforeFeeling = user_before_feeling
            //   ?.split("[")[1]
            //   ?.split("]")[0]
            //   ?.split(",");
            // userBeforeFeeling?.pop();
            // const finalUserBeforeFeeling = userBeforeFeeling?.map((value) =>
            //   parseFloat(value)
            // );
            return (  
            <Collapse defaultActiveKey={['1']} style={{width:"100%"}} onChange={callback}>
               
              <Panel header={`Consumption Entry #${index+1} /  Rating: ${user_rating}`} key={index+1}>
                <Tabs
                  defaultActiveKey="1"
                  tabPosition={"top"}
                  style={{ height: "auto" }}
                >
                  <TabPane key={1} tab={`Overview`} style={{ height: "auto"}}>
                  <Descriptions
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                      style={{ width: "100%", whiteSpace:"nowrap" }}
                    >
                    <Descriptions.Item label="Description">
                    <span style={{ width: "100%", display:"block",  }}>{user_description}</span>
                    </Descriptions.Item>
                      <Descriptions.Item label="Consumption Type" >
                      <span style={{ width: "100%", display:"block", whiteSpace:"nowrap" }}>{consumptionTypeLookUp(consumption_type_id)?.consumption_name_en}</span>
                      </Descriptions.Item>
                    <Descriptions.Item label="Rating">
                      <span style={{ fontSize: "16pt", color: "#D29D1A" }}>
                        {numberRating}
                      </span>
                      {/* TODO: update questions to be using ids for label injection */}
                    </Descriptions.Item>
                    </Descriptions>
                  </TabPane>
                  <TabPane key={0} tab={`Before`} style={{ height: "auto" }}>
                    <Descriptions
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                      style={{ width: "100%" }}
                    >
                     <Descriptions.Item label="Sad (0) / Happy (10)">
                     <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>
                      {rating_1_before}
                      </span>
                      </Descriptions.Item>
                      <Descriptions.Item label="Couchlock (0) / Energetic (10)">
                         <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>
                      {rating_2_before}
                      </span>
                      </Descriptions.Item> 
                      <Descriptions.Item label="Anxious (0) / Mellow (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_3_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Unfocused (0) / Focused (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_4_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="High Pain (0) / Low Pain (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_5_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Uninspired (0) / Creative (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_6_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Tired (0) / Alert (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_7_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Antisocial (0) / Social (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_8_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Nausea (0) / No Nausea (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_9_before}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Psychedelic (0) / Sober (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_10_before}</span> 
                      </Descriptions.Item>
                    </Descriptions>
                  </TabPane>
                  <TabPane key={3} tab={`After`}>
                  <Descriptions
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    >
                     <Descriptions.Item label="Sad (0) / Happy (10)">
                     <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_1_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Couchlock (0) / Energetic (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}> {rating_2_after}</span>
                      </Descriptions.Item> 
                      <Descriptions.Item label="Anxious (0) / Mellow (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_3_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Unfocused (0) / Focused (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_4_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="High Pain (0) / Low Pain (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_5_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Uninspired (0) / Creative (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_6_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Tired (0) / Alert (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_7_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Antisocial (0) / Social (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_8_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Nausea (0) / No Nausea (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_9_after}</span> 
                      </Descriptions.Item>
                      <Descriptions.Item label="Psychedelic (0) / Sober (10)">
                      <span style={{ fontSize: "16pt", whiteSpace:"nowrap", color: "#D29D1A" }}>{rating_10_after}</span> 
                      </Descriptions.Item>
                    </Descriptions>
                  </TabPane>
                </Tabs>
              </Panel></Collapse>
            );
          }
        )
      )}
    </div>
  );
};
